<!--
  - Copyright (c) 2022 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -
  -->

<template>
    <div class="m-ftlaws wbg pb-32" :class="className">
        <div class="center">
            <p>服务热线：总机 0551-63400800   企业 0551-65666555  个人 0551-65666558   工作日 8:30-12:00 14:00-18:00</p>
            <p>人力资源社会保障部门监督投诉电话：12333</p>
            <p>未经goodjobs.cn同意，不得转载网站之所有招聘信息及作品 新安人才网版权所有©2000-2022</p>
            <p>
                <a href="https://www.goodjobs.cn/index.php/action/BusinessLicense?page=1" target="_blank">
                    <img src="https://cdn.ahjob.com.cn/www/images/icon-badge.png" class="mr5" />营业执照&nbsp;
                </a>
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010302000752" target="_blank">
                    <img src="https://cdn.ahjob.com.cn/www/images/icon-beian.png" class="mr5" />皖公网安备 34010302000752号
                </a>
                <span class="u-line">|</span>
                <a href="https://www.goodjobs.cn/index.php/action/BusinessLicense?page=2" target="_blank">人力资源服务许可证</a>
                <span class="u-line">|</span>
                <a href="http://beian.miit.gov.cn" target="_blank">皖ICP备12018891号-3</a>
                <span class="u-line">|</span>
                经营许可证：皖B2-20080016
            </p>
        </div>
    </div>
</template>

<script>
import {getMeta} from '@/api/common';

export default {
    name: 'XaLayoutFooter',
    props: {
        className: {
            type: String,
            default: ''
        }
    },
    created() {
        this.getMeta();
    },
    methods: {
        async getMeta() {
            const { data } = await getMeta();
            document.title = data.title ? data.title : '人事考试网';
            this.$store.commit('setMeta', data);
        }
    }
};
</script>

<style scoped>
@import '@/styles/exam_header.css';
.m-ftlaws{
    border-top-width: 0;
}

</style>
